module.exports = __webpack_public_path__ + "img/78600.20c1397c.jpg";